import mediaQueries from './structure';

export const theme = {
  maxContainer: {
    lg: '1200px',
    sm: '900px',
  },
  colors: {
    primary: '#6BB951',
  },
  transitions: {
    default: '.3s ease',
  },
  mediaQueries,
};

export default theme;



// WEBPACK FOOTER //
// ./src/style/theme.js